export default __webpack_public_path__ + "static/media/1C70BF80-EFB3-4032-A301-AD79D331B1ED_1_105_c.101ad20b.jpeg";